class QuickAdd extends HTMLElement {
  constructor () {
    super()

    this.setupListeners()
    this.initForm = this.initForm.bind(this)
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    document.addEventListener('click', this.handleTrigger)
  }

  async handleTrigger (event) {
    const trigger = event.target.closest(
      '[data-quick-add-external-el="trigger"]',
    )

    if (!trigger) return

    try {
      const sectionsUrl = trigger.dataset.productUrl || window.location.pathname;
      const [path, querystring = ''] = sectionsUrl.split('?');

      const params = new URLSearchParams(querystring);
      params.set('section_id', 'quick-add');

      const response = await fetch(`${path}?${params.toString()}`);
      const res = await response.text();

      const newDOM = new DOMParser().parseFromString(res, 'text/html')
      const bodyContent = newDOM.querySelector('.drw-QuickAdd');
      const wrapper = document.querySelector('[data-quick-add-el="body"]')

      wrapper.innerHTML = bodyContent.outerHTML;
      this.initForm()

      window.drawers.activeDrawerKey = 'quick-add';
    } catch (error) {
      window.drawers.activeDrawerKey = '';
    }
  }

  initForm () {
    const formEl = this.querySelector('form')
    formEl.addEventListener('submit', this.handleFormSubmit.bind(this))

    const variantSelectEl = formEl.querySelector('[data-quick-add-el="variant-select"]')
    variantSelectEl.addEventListener('change', this.handleVariantOptionChange.bind(this))
  }

  handleVariantOptionChange (event) {
    const selectEl = event.target

    const selectedOption = selectEl.options[selectEl.selectedIndex];
    const selectedVariantId = selectedOption.getAttribute('data-variant-id');

    const formEl = this.querySelector('form')
    const variantInput = formEl.querySelector('input[name="id"]')

    variantInput.value = selectedVariantId

    const ctaSizeEl = formEl.querySelector('.cta-size')
    if (ctaSizeEl) {
      const ctaValue = selectedOption.getAttribute('data-cta-value')
      ctaSizeEl.innerHTML = ctaValue ? `${ctaValue} -` : ''
    }
  }

  handleFormSubmit (event) {
    event.preventDefault();

    const formEl = this.querySelector('form')
    const formData = new FormData(formEl);

    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      headers: {
        "X-Requested-With": "XMLHttpRequest"
      }
    })
    .then(response => response.json())
    .then(data => {
      window.dispatchEvent(new CustomEvent('quickAdd:itemAdded', {
        detail: {
          item: data,
        }
      }));

      window.drawers.activeDrawerKey = '';
    })
    .catch(error => {
      console.error("Error adding to cart:", error);
    });
  }
}

if (!customElements.get('quick-add')) {
  customElements.define('quick-add', QuickAdd)
}
